export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/bigcommerce.eeb80c8.svg";